import React from 'react';
import LogoLang from '@components/LogoLang';
import { Link } from 'react-router-dom';

const BlockedPage = () => {
  return (
    <div className="grid min-h-screen place-content-center px-6 lg:px-8">
      <div>
        <LogoLang />
      </div>
      <h1 className="mt-10 text-3xl font-bold tracking-tight text-gray-900 sm:text-5xl text-center">
        Diese Seite wurde gesperrt.
      </h1>
      <p className="mt-4 text-base text-gray-600 sm:mt-6 text-center">
        Falls das nicht so sein sollte, wende dich bitte an unseren Support.
      </p>
      <div className="mt-10 flex justify-center">
        <Link to="/" className="text-sm font-semibold leading-7 text-gray-900">
          <span aria-hidden="true">&larr;</span> Zur Homepage
        </Link>
      </div>
    </div>
  );
};

export default BlockedPage;
